import { render, staticRenderFns } from "./StoryOverlayController.vue?vue&type=template&id=2bc99234&scoped=true&"
import script from "./StoryOverlayController.vue?vue&type=script&lang=ts&"
export * from "./StoryOverlayController.vue?vue&type=script&lang=ts&"
import style0 from "./StoryOverlayController.vue?vue&type=style&index=0&id=2bc99234&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc99234",
  null
  
)

export default component.exports